import "babel-polyfill";

import Vue from "vue";
//import Vuex from 'vuex'
import vmApp from "./application/index.vue";
//import store from './store'
//Vue.use(Vuex)

/*const store =new Vuex.Store({
  state: {
      count: 0
    },
    mutations:
    {
      increment (state) {
        state.count++
      }
    }
})*/

//new Vue(vmApp,store).$mount('#application')
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo);
new Vue(vmApp).$mount("#application");
